import { memo } from 'react';
import { Icon, TableSelectable, Tooltip } from '@hotjar/hotsauce';
import { transformBrowserNameToIcon } from '../../../utils/transformBrowserNameToIcon';

interface BrowserCellProps {
  browser: string;
}

const RecordingsBrowserCell = ({ browser }: BrowserCellProps): JSX.Element => (
  <TableSelectable.Cell>
    <Tooltip text={browser} placement="top" appendTo="parent">
      <Icon icon={transformBrowserNameToIcon(browser)} size="m" />
    </Tooltip>
  </TableSelectable.Cell>
);

export const BrowserCell = memo(RecordingsBrowserCell);
